import SocialLinksRow from "./SocialLinksRow";

/**
 * "Follow for new studies" mini-strip. Used after the primary CTA has
 * already been shown , the goal is to give visitors who aren't ready
 * for the primary action a softer, lower-commitment way to stay in
 * touch (and a second channel we can re-reach them on).
 *
 * Two variants:
 *  - "dark"  , for use on the dark hero / dark sections
 *  - "light" , for use on white sections (e.g. inside cards)
 *
 * `source` / `campaign` flow straight into UTM params so PostHog can
 * tell us which placement actually drives followers.
 */
export default function FollowStrip({
  source = "site",
  campaign = "follow-strip",
  medium = "follow-strip",
  variant = "dark",
  className = "",
  title = "Or follow us for new study announcements",
  subtitle = "We post new studies on Facebook, Instagram, TikTok and X before they're on the website.",
  testId = "follow-strip",
}) {
  const isDark = variant === "dark";
  const containerCls = isDark
    ? "bg-white/[0.04] border-white/10 text-white"
    : "bg-[var(--bone-soft)] border-[var(--light-border)] text-[var(--charcoal)]";
  const subtitleCls = isDark ? "text-white/60" : "text-[var(--text-muted)]";

  return (
    <div
      className={`rounded-2xl border p-5 md:p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 ${containerCls} ${className}`}
      data-testid={testId}
    >
      <div>
        <p className="text-[15px] font-semibold leading-snug">{title}</p>
        <p className={`text-[13px] mt-1 leading-relaxed max-w-md ${subtitleCls}`}>
          {subtitle}
        </p>
      </div>
      <SocialLinksRow
        source={source}
        medium={medium}
        campaign={campaign}
        variant={variant}
        size="lg"
        testIdPrefix={`${testId}-link`}
      />
    </div>
  );
}
